/* eslint-disable quotes */
export default {
  label: {
    ok: 'ঠিক আছে',
    confirm: 'নিশ্চিত করুন',
    cancel: 'বাতিল করুন',
    delete: 'মুছুন',
    download: 'ডাউনলোড',
    submit: 'জমা দিন',
    search: 'অনুসন্ধান করুন',
    recharge: 'রিচার্জ',
    rechargePrice: 'রিচার্জ({{price}})',
    withdraw: 'প্রত্যাহার করুন',
    withdrawal: 'প্রত্যাহার করুন',
    transfer: 'স্থানান্তর',
    balance: 'ভারসাম্য',
    deposit: 'জমা',
    walletType: 'মানিব্যাগের ধরণ',
    id: 'আইডি',
    payment: 'পেমেন্ট',
    addBank: 'অ্যাকাউন্ট যোগ করুন',
    updateBank: 'ব্যাংক কার্ড আপডেট করুন',
    email: 'ইমেইল',
    finish: 'সমাপ্ত করুন',
    save: 'সংরক্ষণ করুন',
    records: 'রেকর্ডসমূহ',
    time: 'সময়',
    order: 'অর্ডার',
    OTP: 'ওটিপি',
    del: 'মুছুন',
    copy: 'কপি করুন',
    won: 'জিতেছে',
    'agent-rule': 'এজেন্ট নিয়ম',
    loadMore: 'আরও লোড করুন',
    logIn: 'লগইন করুন',
    tip: 'টিপ',
    'no-more-content': 'আর কোনও কন্টেন্ট উপলব্ধ নেই',
    lottery: 'লটারি',
    live: 'লাইভ',
    all: 'সব',
    noMore: 'আর নেই',
    loading: 'লোড হচ্ছে...',
    win: 'জয়',
    times: 'বার',
    bet: 'বাজি',
    unused: 'অব্যবহৃত',
    total: 'মোট',
  },
  tip: {
    success: 'সফলভাবে',
    copysuccess: 'সফলভাবে কপি করা হয়েছে',
    closeIn: '{{second}} সেকেন্ডে বন্ধ করুন',
    receiveInApp: 'স্পিনবাজি অ্যাপে রিসিভ করুন.',
  },
  text: {},
  defaultPage: {
    noMore: 'আর কোন তথ্য নেই',
  },
  home: {
    scratchOff: 'আঁচড়ে ফেলা',
    copied: 'কপি সফলভাবে করা হয়েছে, অনুগ্রহ করে বন্ধুদের সাথে শেয়ার করুন।',
    tip: {
      beforDownload: 'অনুগ্রহ করে নিবন্ধন করুন অথবা লগইন করুন',
    },
    label: {
      upcoming: 'আসন্ন ঘটনাবলী',
      liveEvents: 'লাইভ ইভেন্ট',
    },
  },
  alert: {
    logout: 'লগ আউট',
    sureLogout: 'তুমি কি নিশ্চিত যে তুমি লগ আউট করতে চাও?',
  },
  warning: {
    unopen: 'এখনও সক্ষম করা হয়নি',
    initializin: 'শুরু হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন',
  },
  notification: {
    title: 'বিজ্ঞপ্তি',
    announcements: 'ঘোষণা',
    systemMessage: 'সিস্টেম বার্তা',
  },
  vip: {
    currentLevel: 'বর্তমান স্তর',
    collected: 'সংগ্রহ করতে হবে',
    finished: 'সম্পন্ন করতে হবে',
    received: 'প্রাপ্ত হয়েছে',
    recharge: 'রিচার্জ',
    reached: 'দাবি করা হয়েছে',
    unReached: 'অর্জন হয়নি',
    pending: 'অপেক্ষমান',
    move: 'স্তরে পৌঁছাতে আরও অনেক কিছু',
    title: 'ভিআইপি',
    table: {
      level: 'ভিআইপি স্তর',
      reward: 'পুরস্কার',
      bouns: 'বোনাস',
      spin: 'স্পিন',
    },
    label: {
      reward: 'ভিআইপি স্তরের পুরষ্কার',
      weekCard: 'সাপ্তাহিক কার্ড',
      weekReward: 'ভিআইপি সাপ্তাহিক পুরষ্কার',
      withdrawAmount: 'উত্তোলনের পরিমাণ',
      withdrawTimes: 'উত্তোলনের সময়',
      withdrawFee: 'উত্তোলনের ফি',
      silverWeekCard: 'সিলভার সাপ্তাহিক কার্ড',
      goldWeekCard: 'গোল্ড সাপ্তাহিক কার্ড',
      diamondWeekCard: 'ডায়মন্ড সাপ্তাহিক কার্ড',
      day: 'দিন',
      rewardDetails: 'পুরষ্কারের বিবরণ',
      rewardAccumulation: 'পুরষ্কার জমা',
      vipUpgrade: 'ভিআইপি আপগ্রেড',
      buyWeekCard: 'সাপ্তাহিক কার্ড কেনার অধিকার',
      weekCardRecharge: 'সাপ্তাহিক কার্ড রিচার্জ',
      weekCardBuyRecord: 'সাপ্তাহিক কার্ড কেনার রেকর্ড',
    },
    tip: {
      levelDetail: {
        t01: 'ভিআইপি লেভেল রিওয়ার্ড',
        p1: 'এককালীন পুরষ্কার পেতে ভিআইপি লেভেল <0>{{level}}</0> এ পৌঁছান',
        t02: 'সাপ্তাহিক ভিআইপি রিওয়ার্ড',
        p2: 'সাপ্তাহিক বেস রিওয়ার্ড <0>{{money}}</0> পেতে ভিআইপি লেভেলে <0>{{level}}</0> পৌঁছান।আপনি জমা, বাজি এবং সক্রিয় থাকার মাধ্যমে পুরষ্কার গুণক বাড়াতে পারেন।',
        t03: 'ভিআইপি উইথড্রয়াল',
        p3: 'ভিআইপি লেভেল <0>{{level}}</0> এ, প্রতি প্রত্যাহারের সর্বোচ্চ পরিমাণ <0>{{money}}</0>',
        t04: 'ভিআইপি উইথড্রয়াল ফ্রিকোয়েন্সি',
        p4: 'ভিআইপি লেভেল <0>{{level}}</0> এ, আপনি প্রতিদিন <0>{{count}}</0> বার পর্যন্ত প্রত্যাহার করতে পারেন',
        t05: 'ভিআইপি উইথড্রয়াল ফি',
        p5: 'ভিআইপি লেভেল <0>{{level}}</0> এ, প্রতি লেনদেনের জন্য প্রত্যাহার ফি <0>{{money}}</0> এর মতো কম।',
      },
      remainTime: 'সাপ্তাহিক কার্ডের অবশিষ্ট ধারণ সময়:',
      remainTimeBottom:
        'সাপ্তাহিক কার্ডের পুরস্কার ক্রয়ের পরের দিন প্রদান করা হবে',
      upgrade: {
        to: 'আমাদের মূল্যবান ভিআইপিদের প্রতি:',
        subtitle:
          'আপনার অব্যাহত সমর্থন আমাদের এগিয়ে নিয়ে যায়! এই সিস্টেম আপগ্রেডের মাধ্যমে, আপনি উপভোগ করবেন:',
        li1: 'মসৃণ এক্সক্লুসিভ পরিষেবা',
        li2: 'একেবারে নতুন ভিআইপি বৈশিষ্ট্য',
        li3: 'আমাদের প্রশংসার প্রতীক হিসেবে, আমরা আপনাকে একটি বিশেষ আপগ্রেড উপহার প্যাকেজ দিচ্ছি!',
      },
      weekCardReward: {
        title: 'সাপ্তাহিক কার্ড পুরষ্কার',
        p1: 'সাপ্তাহিক কার্ড পুরষ্কার: আপনার সাপ্তাহিক কার্ড ধরে রাখার সময় জমা হওয়া পুরষ্কার।',
        p2: '(দ্রষ্টব্য: এগুলি দাবি করতে আপনাকে প্রতিদিন লগ ইন করতে হবে। মিস করা দিনগুলি পুরষ্কার দেওয়া হবে না।)',
      },
      weekCard: {
        p1: 'এখনই রিচার্জ করুন এবং তাৎক্ষণিকভাবে <0>{{money}}</0> পান',
        p2: 'অতিরিক্ত দৈনিক বোনাস পান:',
        p3: 'প্রাপ্ত মোট মূল্য: <0>{{money}}</0>',
      },
      weekReward: {
        t1: 'এখানে আপনার সাপ্তাহিক ভিআইপি পুরষ্কারগুলি',
        t2: 'আপনার পুরষ্কারগুলি কীভাবে বাড়াবেন?',
        p1: 'ভিআইপি পুরষ্কারগুলি গত সপ্তাহের আপনার অ্যাপ-মধ্যস্থ কার্যকলাপের উপর নির্ভর করে। জমা, বাজি এবং ব্যস্ততা আপনার গুণক বৃদ্ধি করে।',
        p2: 'প্রতিটি ব্যবহারকারীর পুরষ্কারে <0>{{money}}</0> এরও বেশি উপার্জনের সুযোগ রয়েছে!',
        yourReward: 'গত সপ্তাহের আপনার পুরষ্কার',
      },
      weeklyRemain: 'আপনার সাপ্তাহিক কার্ড বাকি',
      confirmBuyTitle: 'সাপ্তাহিক কার্ড কিনুন',
      confirmBuy: '{type}} সাপ্তাহিক কার্ড কেনার বিষয়টি নিশ্চিত করেছেন?',
      weekCardBuySuccess: '{{type}} সাপ্তাহিক কার্ড সফলভাবে কিনুন',
      noVip:
        'সাপ্তাহিক কার্ডটি শুধুমাত্র ভিআইপি ব্যবহারকারীদের ক্রয় করতে সহায়তা করে, দয়া করে আপগ্রেড করুন',
    },
    rules: {
      title: 'ভিআইপি সাপ্তাহিক কার্ড ব্যবহারের নিয়ম',
      subtitle1: 'ভিআইপি সাপ্তাহিক পাস কী?',
      sub1paragraph1:
        'এক্সক্লুসিভ সুবিধা: শুধুমাত্র VIP>=4 ব্যবহারকারীদের জন্য, ক্রয়ের পরই কার্যকর',
      sub1paragraph2:
        ' বৈধতার সময়কাল: প্রতিটি সাপ্তাহিক কার্ড ৭ স্বাভাবিক দিন (বর্ধিত করা যেতে পারে)',
      subtitle2: 'দ্বিগুণ পুরষ্কার',
      sub2paragraph1:
        'রিচার্জের পরিমাণের সমতুল্য মূল্য(উদাহরণস্বরূপ, ৳৩০ রিচার্জ করলে ৩০ পয়েন্ট পাওয়া যাবে।)',
      sub2paragraph2:
        'বৈধতার সময়কাল: প্রতিটি সাপ্তাহিক কার্ড ৭ স্বাভাবিক দিন (বর্ধিত করা যেতে পারে)',
      subtitle3: 'পুরস্কার সংগ্রহ',
      buyTip:
        'ক্রয়ের দিনে আপনি রিচার্জের সমপরিমাণ পাবেন, এবং সাপ্তাহিক কার্ডের পুরস্কার পরের দিন থেকে বিতরণ শুরু হবে',
      sub3paragraph1:
        'প্রতিদিন লগ ইন করুন এবং পুরষ্কারগুলি স্বয়ংক্রিয়ভাবে সেই দিনে বিতরণ করা হবে। লগ ইন না করলে, পুরষ্কারগুলি পরের দিন পর্যন্ত স্থগিত করা হবে।',
      sub3paragraph2:
        'মেয়াদ শেষ হওয়ার পরে কোনও রিডিম্পশন নেই: সাপ্তাহিক কার্ডের মেয়াদ শেষ হওয়ার পরে যে পুরষ্কারগুলি দাবি করা হয় না তা অবৈধ হবে',
      subtitle4: 'ওভারলে সুবিধা',
      sub4paragraph1:
        'একই ধরনের সর্বাধিক দুটি সাপ্তাহিক কার্ড একসাথে ধরে রাখা যাবে',
      sub4paragraph2:
        'বিভিন্ন ধরনের সাপ্তাহিক কার্ড: একসাথে ৩ ধরনের সাপ্তাহিক কার্ড সক্রিয় করা যেতে পারে',
      sub4example:
        '(উদাহরণ: প্রথম দিনে A কার্ড কিনুন, দ্বিতীয় দিনে B কার্ড কিনুন → দ্বিতীয় দিন থেকে A+Breward উভয় উপভোগ করুন)',
      subtitle5: 'VIP এক্সক্লুসিভ',
      sub5paragraph1:
        'শুধুমাত্র VIP ব্যবহারকারীরা এই পণ্যটি দেখতে/ক্রয় করতে পারবেন, অ-VIP ব্যবহারকারীরা এটি ব্যবহার করতে পারবেন না',
      sub5paragraph2:
        'সোমবার [গোল্ডেন উইক কার্ড] কিনুন → পরের সোমবার পর্যন্ত প্রতিদিন সোনার পুরষ্কার পান',
      sub5paragraph3:
        'শুক্রবার আবার একই জিনিস কিনুন → মেয়াদের সময়কাল পরবর্তী রবিবার পর্যন্ত বাড়ানো হয়েছে এবং পুরষ্কার এখনও দাবি করা যেতে পারে',
      sub5remark1:
        'পুরষ্কার দাবি করতে এবং এর সুবিধা সর্বাধিক করতে প্রতিদিন লগ ইন করার পরামর্শ দেওয়া হচ্ছে সাপ্তাহিক কার্ড!',
      sub5remark2:
        'আপনার যদি কোনও প্রশ্ন থাকে, তাহলে অনুগ্রহ করে গ্রাহক পরিষেবার সাথে যোগাযোগ করুন।',
    },
    success: 'সফলভাবে গ্রহণ করুন',
    rechargeTip:
      'রিচার্জ <0>{{price}}</0> লেভেল {{level}} এ পৌঁছানোর জন্য আরও বেশি করুন',
    incoming: 'এই লেভেলে পৌঁছানোর পর, লুকানো লেভেলটি আনলক হয়ে যায়',
  },
  filter: {
    today: 'আজ',
    yesterday: 'গতকাল',
    days: '{{day}} দিন',
    time: 'Select a time',
    name: 'Filter',
  },
  luckyspin: {
    add: 'যোগ করুন',
    spin: 'স্পিন',
    won: 'জিতেছে',
    winner: 'বড় বিজয়ীরা',
    mySpin: 'আমার স্পিন',
    myfree: 'আমার বিনামূল্যে',
    morefree: 'আরও বিনামূল্যে',
    free: 'বিনামূল্যে',
    usefreefirst: 'প্রথমে বিনামূল্যে ব্যবহার করুন',
  },
  invitation: {
    rule: {
      title: 'আমন্ত্রণের নিয়ম',
      paragraph: {
        invite:
          'অতিরিক্ত প্ল্যাটফর্ম পুরস্কার পেতে বন্ধুদের আমন্ত্রণ জানান এবং রিচার্জ করুন!',
        after:
          'দাবি করার পর, ১০ মিনিটের মধ্যে পুরস্কারগুলি সরাসরি ওয়ালেট ব্যালেন্সে বিতরণ করা হবে।',
      },
      table: {
        invite: 'Invite Account',
        deposit: 'Deposit Account',
        bonus: 'বোনাস',
        people: 'People',
        inviteCount: 'আমন্ত্রণ গণনা',
        reward: 'পুরস্কার',
      },
      detail: {
        title: 'নিয়ম',
        paragraph1:
          'যখন আমন্ত্রিত অ্যাকাউন্টের সংখ্যা পৌঁছে যাবে এবং প্রতিটি অ্যাকাউন্ট রিচার্জের পরিমাণ পূরণ করতে পারবে, তখনই আপনি বোনাস পেতে পারবেন।',
        paragraph2:
          'আমন্ত্রণ অ্যাকাউন্টটি প্রয়োজনীয়তা পূরণ করে, কিন্তু অ্যাকাউন্টের রিচার্জের পরিমাণ প্রয়োজনীয়তা পূরণ করে না, এবং বোনাস দাবি করা যাবে না।',
        paragraph3:
          'অনুগ্রহ করে ইভেন্টের সময়কালের মধ্যে ইভেন্ট বোনাস দাবি করুন। ইভেন্টের মেয়াদ শেষ হওয়ার পরে সমস্ত বোনাস ক্লিয়ার করা হবে।',
        paragraph4:
          'অনুগ্রহ করে ইভেন্টের সময়কালের মধ্যে কাজটি সম্পন্ন করুন। ইভেন্টের মেয়াদ শেষ হওয়ার পরে, আমন্ত্রণ রেকর্ডটি সাফ করা হবে।',
      },
    },
    home: {
      title: 'বন্ধুদের আমন্ত্রণ জানান',
      'code-title': 'আমার আমন্ত্রণ কোড',
      income: 'ক্রমবর্ধমান \nআয়',
      count: 'মোট আমন্ত্রিত \nসংখ্যা',
      record: 'আমন্ত্রণ \nরেকর্ড',
      'reward-rules': 'আমন্ত্রণ \nপুরস্কার নিয়ম',
      bouns: 'বোনাস',
      join: 'এজেন্সিতে যোগদান করুন',
      'join-tip': 'এজেন্ট হয়ে আরও কমিশন উপার্জন করুন।',
      invites: 'আমন্ত্রিতদের সংখ্যা',
      recharges: 'প্রতি জন রিচার্জ',
      deposit: 'জমার সংখ্যা',
      'go-complete': 'সম্পূর্ণ হও',
      completed: 'সম্পন্ন হয়েছে',
      rules: 'নিয়ম',
      'copy-text':
        'লিঙ্ক কপি করা হয়েছে, এখনই বন্ধুদের আমন্ত্রণ জানাতে WhatsApp বা টেলিগ্রামে যান।',
      inviteGet:
        '{{count}} জন বন্ধুকে আমন্ত্রণ জানান এবং নিম্নলিখিত সুবিধাগুলি পান:',
    },
  },
  proxy: {
    title: 'এজেন্সি সেন্টার',
    tier: 'স্তর{{number}}',
    all: 'সব',
    search: 'Search Phone number',
    join: 'এজেন্সিতে যোগদান করুন',
    rules: {
      header: 'আমন্ত্রণের নিয়ম',
      title: 'rপ্রচারণার অংশ',
      subtitle: 'প্রোগ্রামএই কার্যকলাপটি দীর্ঘ সময়ের জন্য বৈধ',
      paragraph1:
        'বন্ধুদের আমন্ত্রণ জানানোর সময় ৪টি রেফারেল স্তর থাকে। যদি A B কে আমন্ত্রণ জানায়, B A এর লেভেল ১ রেফারেল হয়ে যায়। যদি B C কে আমন্ত্রণ জানায়, C B এর লেভেল ১ রেফারেল হয়ে যায় এবং একই সাথে A এর লেভেল ২ রেফারেল হয়ে যায়। যদি C D কে আমন্ত্রণ জানায়, D C এর লেভেল ১ রেফারেল, B এর লেভেল ২ রেফারেল এবং A এর লেভেল ৩ রেফারেল হয়ে যায়।',
      paragraph2:
        'বন্ধুদের নিবন্ধনের জন্য আমন্ত্রণ জানানোর সময়, আপনাকে অবশ্যই প্রদত্ত আমন্ত্রণ লিঙ্কটি পাঠাতে হবে অথবা আমন্ত্রণ কোডটি ম্যানুয়ালি লিখতে হবে যাতে আপনার বন্ধুরা আপনার লেভেল 1 অধস্তন হয়ে ওঠে।',
      paragraph3:
        'আমন্ত্রিত ব্যক্তি আমন্ত্রণকারীর আমন্ত্রণ কোডের মাধ্যমে নিবন্ধন করেন এবং জমা সম্পন্ন করেন, এর কিছুক্ষণ পরেই কমিশন অবিলম্বে গৃহীত হবে',
      paragraph4:
        'কমিশনের শতাংশ এজেন্ট স্তরের উপর নির্ভর করে। এজেন্টদের জন্য চারটি স্তরের সিস্টেম রয়েছে। আরও বেশি লোককে আমন্ত্রণ জানান এবং আরও বেশি কমিশন অর্জনের জন্য আপনার এজেন্ট স্তর দ্রুত আপডেট করুন',
      paragraph5:
        'সাব-এজেন্টদের কাছ থেকে প্রাপ্ত রিচার্জ বোনাসের শতাংশ এজেন্টের নিজস্ব স্তরের উপর নির্ভর করে পরিবর্তিত হয',
      'paragraph6-1':
        'কমিশনের শতাংশ সদস্যপদ স্তরের উপর নির্ভর করে। সদস্যপদ স্তর যত বেশি হবে, বোনাসের শতাংশ তত বেশি হবে। বিভিন্ন ধরণের খেলার ক্ষেত্রেও বিভিন্ন পেমেন্ট শতাংশ থাকে',
      'paragraph6-2':
        'কমিশনের হার সুনির্দিষ্টভাবে নিম্নরূপ ব্যাখ্যা করা হয়েছে',
      paragraph7:
        'শীর্ষ ২০ কমিশন র‍্যাঙ্কিং এলোমেলোভাবে একটি পৃথক বোনাস সহ প্রদান করা হবে',
      tier: 'স্তর{{number}}',
      'agent-level': 'Agent Level',
      'commission-level': 'Commission Level',
      'team-member': 'Team\nMember',
      'team-recharge': 'Team\nRecharge',
      'team-betting': 'Team\nBetting',
      lottery: 'Lottery commission percentage',
      scratch: 'Scratch card Slots commission percentage',
      casino: 'Casino commission percentage',
      sports: 'Sports commission percentage',
    },
    filter: {
      recharge: 'রিচার্জ',
      commission: 'কমিশন',
    },
    user: {
      id: 'ID:',
      'register-date': 'নিবন্ধনের তারিখ:',
      'total-user': 'মোট ব্যবহারকারী:',
      'total-commission': 'মোট কমিশন:',
      'bet-user': 'বেট ব্যবহারকারী',
      'betting-user': 'বাজি ধরা ব্যবহারকারীরা',
      'new-user': 'নতুন ব্যবহারকারী',
      'new-user-title': `এর দলের তথ্য`,
      'recharge-user': 'রিচার্জ ব্যবহারকারীরা',
      users: 'ব্যবহারকারীরা',
      active: 'সক্রিয়',
      total: 'মোট তথ্য',
      today: 'আজকের ব্যবহারকারীর তথ্য',
      commission: 'কমিশন',
      recharge: 'রিচার্জ',
      betting: 'বাজি ধরা',
      wonlost: 'জয়/পরাজয়',
      'error-no-performance':
        'এই ব্যবহারকারীর বর্তমানে কোনও পারফর্ম্যান্স নেই। \nকোন সমস্যা আছে কি?',
      contact: 'এখনই যোগাযোগ করুন',
      'error-no-play':
        'এই ব্যবহারকারী গত ৭ দিনে কোনও গেম খেলেননি।\n কোনও সমস্যা আছে কি?',
      'up-line': 'আপ-লাইন',
    },
    'commission-detail': {
      title: 'কমিশনের বিস্তারিত',
      total: 'মোট কমিশন',
      sort: 'কমিশন সাজান',
      time: 'সময় বাছাই',
      highlow: 'উচ্চ থেকে নিম্ন',
      lowhigh: 'নিম্ন থেকে উচ্চ',
      phone: 'ফোন নম্বর:',
      user: {
        title: 'ব্যবহারকারীর বিবরণ',
        amount: 'রিচার্জের পরিমাণ',
        rebate: 'ছাড়',
        commission: 'রিচার্জ কমিশন',
        game: 'খেলা',
        result: 'ফলাফল',
      },
    },
    'commission-base': {
      commissionRate: 'কমিশন রেট',
      commissionType: 'আদর্শ',
      commissionTier1: 'স্তর ১',
      commissionTier2: 'স্তর ২',
      commissionTier3: 'স্তর ৩',
      commissionTier4: 'স্তর ৪',
      commissionLv: 'Invite More Friends To Upgrade To Lv',
      commissionLvE: ' Earn Higher Commissions.',
      commissionLv4: 'উচ্চ কমিশন অর্জন করুন',
    },
    'team-report': {
      'new-user': 'নতুন ব্যবহারকারী',
      'betting-users': 'রিচার্জ ব্যবহারকারীরা',
      recharge: 'রিচার্জ',
      betting: 'বাজি ধরা',
      'recharge-commission': 'রিচার্জ কমিশন',
      'betting-commission': 'বাজি কমিশন',
      'my-teams': 'আমার দল',
      'user-id': 'ব্যবহারকারী আইডি',
      user: 'ব্যবহারকারী',
      commission: 'কমিশন',
      'won-loss': 'জয়/পরাজয়',
      won: 'জয়',
      loss: 'পরাজয়',
      'user-view': 'ব্যবহারকারীর দর্শন',
      'up-line': 'আপ-লাইন',
      'register-date': 'নিবন্ধনের তারিখ:',
      'games-played7': 'গত ৭ দিনে খেলা গেম',
      'game-name': 'খেলার নাম',
      tier: 'স্তর',
      'no-search': 'অনুসন্ধানে কোন ফলাফল পাওয়া যায়নি',
      'no-data': 'কোন তথ্য নেই',
      next: 'পরবর্তী',
    },
    'tier-card': {
      'recharge-amount': 'রিচার্জের পরিমাণ',
      'recharge-commission': 'রিচার্জ কমিশন',
      'bet-amount': 'Bet amount',
      'bet-commission': 'Bet commission',
      detail: 'Details',
      check: 'Check',
    },
    subordinates: {
      title: 'New subordinates',
      today: 'আজ',
      yesterday: 'গতকাল',
      month: 'This Month',
    },
    team: {
      title: 'টিম রিপোর্ট',
      grade: 'Grade',
      date: 'Date:',
      time: 'Select Time',
      total: 'মোট তথ্য',
      today: 'আজ',
      yesterday: 'গতকাল',
      threedays: '৩ দিন',
      sevendays: '৭ দিন',
      fifteendays: '১৫ দিন',
      thirtydays: '৩০ দিন',
      deposit: 'Deposit number',
      betting: 'বাজি কমিশন',
      recharge: 'রিচার্জ কমিশন',
      search: 'অধস্তনদের ফোন নম্বর লিখুন',
    },
    home: {
      'agent-id': 'Agent ID:',
      rebate: 'ছাড়',
      'my-invitation-code': 'আমার আমন্ত্রণ কোড',
      'reset-link': 'লিঙ্ক রিসেট করুন',
      'invitation-link': 'আমন্ত্রণ লিঙ্ক',
      'team-report': 'টিম রিপোর্ট',
      'commission-detail': 'কমিশনের বিস্তারিত',
      'new-subordinates': 'New subordinates',
      'invitation-rules': 'আমন্ত্রণের নিয়ম',
      'agent-line-customer-service': 'এজেন্ট লাইন গ্রাহক পরিষেবা',
      'commission-ranking': 'কমিশন র‍্যাঙ্কিং',
      'agents-whose-commissions-exceed': 'Agents whose commissions exceed ',
      me: 'Me',
    },
    'new-user': {
      title: 'নতুন ব্যবহারকারী',
      today: 'New Users Today:',
      error:
        'No new users yet! \nInvite your friends to earn more commissions.',
      invite: 'Invite now',
    },
    'commission-card': {
      commission: 'Commission Amount',
    },
  },
  'invitation-record': {
    'invitation-record': 'আমন্ত্রণ রেকর্ড',
    status: 'অবস্থা',
    'registration-time': 'নিবন্ধনের সময়',
    'invited-friends': 'এখনও কোন বন্ধুকে আমন্ত্রণ জানাননি।',
    invite: 'আমন্ত্রণ জানান',
    'bonus-detail': 'বোনাস {{bonus}} বিবরণ',
    noInvitedFriend: 'কোন মিলযুক্ত আমন্ত্রণ রেকর্ড নেই',
  },
  referral: {
    copy: 'Copy',
    invite: 'আমন্ত্রণ জানান',
    copied: 'সফলভাবে কপি করা হয়েছে',
    label: {
      title: 'SIGN UP AND GET GIFTS',
    },
    tip: {
      desc: 'If you do not have an account, it will be automatically registered for you',
    },
  },
  'error-pages': {
    refresh: {
      label: {
        title: 'কিছু একটা ভয়াবহ ভুল হয়ে গেছে!',
        'sub-title': 'আপনার পৃষ্ঠাটি রিফ্রেশ করুন।',
        'try-again': 'আবার চেষ্টা করো',
      },
    },
    'no-data': {
      label: {
        title: 'কোন তথ্য নেই',
        empty: 'সব খালি',
      },
    },
    'not-found': {
      label: {
        title: 'বর্তমান নেটওয়ার্ক সিগন্যালটি খারাপ।',
        'sub-title': 'আপনার নেটওয়ার্ক পরীক্ষা করুন।',
      },
    },
    'no-result': {
      label: {
        title: 'কোন অনুসন্ধান ফলাফল নেই!',
      },
    },
  },
  share: {
    copy: 'Copy',
    invite: 'আমন্ত্রণ জানান',
    'copy-success': 'সফলভাবে কপি করা হয়েছে',
    copied: 'সফলভাবে কপি করা হয়েছে',
  },
  casino: {
    big: 'বড়',
    win: 'জয়',
    detail: {
      title: 'ভাগ্যবান খেলোয়াড়দের অভিনন্দন',
    },
    winPrize: 'পুরস্কার জিতুন',
    playnow: 'এখন খেলুন',
    title: 'ক্যাসিনো',
  },
  login: {
    label: {
      login: 'লগইন করুন',
      skip: 'স্কিপ',
      sign: 'সাইন আপ করুন',
      next: 'পরবর্তী',
      'select-region': 'Select Region',
      'otp-login': 'ওটিপি লগইন',
      'password-login': 'পাসওয়ার্ড লগইন',
      'get-otp': 'ওটিপি পান',
      'set-password': 'পাসওয়ার্ড সেট করুন',
      phoneLogin: 'ফোন লগইন',
      accountLogin: 'অ্যাকাউন্ট লগইন',
      phoneSign: 'ফোন সাইন আপ',
      accountSign: 'অ্যাকাউন্ট সাইন আপ',
      account: 'অ্যাকাউন্ট',
    },
    tip: {
      'no-phone': 'অনুগ্রহ করে ফোন নম্বর লিখুন',
      'no-password': 'অনুগ্রহ করে পাসওয়ার্ড লিখুন',
      'no-otp': 'অনুগ্রহ করে OTP লিখুন',
      phone: 'ফোন নম্বর লিখুন',
      account: 'ফোন নম্বর লিখুন(10 সংখ্যা)',
      password: 'পাসওয়ার্ড লিখুন (6-15)',
      passwordRule:
        'দৈর্ঘ্য অবশ্যই ৬~১৫ হতে হবে এবং সংখ্যা এবং অক্ষর উভয়ই থাকতে হবে',
      'confirm-password': 'পাসওয়ার্ড নিশ্চিত করুন',
      forgot: 'আপনার পাসওয়ার্ড ভুলে গেছেন?',
      'new-account': 'একটি অ্যাকাউন্ট প্রয়োজন?',
      'sing-in': 'সাইন আপ করুন',
      otp: 'ওটিপি লিখুন',
      'referral-code': 'রেফারেল কোড',
      confrim18: 'আমি নিশ্চিত করছি যে আমার বয়স ১৮+।',
      'allow-notify':
        'আমরা আপনাকে গুরুত্বপূর্ণ বিজয়ী তথ্য জানাতে পারব এই ফোন নম্বরের মাধ্যমে।',
      'has-account': 'ইতিমধ্যেই একজন ব্যবহারকারী?',
      'sign-in': 'লগইন করুন',
      page18: 'আমি নিশ্চিত করছি যে আমার বয়স ১৮+।',
      notify:
        'এই মোবাইল নম্বরের মাধ্যমে আমরা আপনাকে গুরুত্বপূর্ণ বিজয়ী তথ্য জানাতে পারব।',
      'pwd-dif': 'দুটি পাসওয়ার্ড অসঙ্গত।',
      modified: 'পাসওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে।',
      'game-not-active':
        'দুঃখিত, গেমটি রক্ষণাবেক্ষণের অধীনে রয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
      accountDuplicate:
        'এই অ্যাকাউন্টটি ইতিমধ্যে ব্যবহারিকারীর অধীনে রয়েছে, অনুগ্রহ করে পরিবর্তন করুন।',
    },
    direct_entry: 'সরাসরি প্রবেশ',
  },
  paidSuccess: {
    label: {
      title: 'পেমেন্ট',
      subTitle: 'সফলভাবে পরিশোধ করা হয়েছে',
      viewOrder: 'অর্ডার দেখুন',
      backHome: 'হোমে ফিরুন',
      content:
        'বাজি সফলভাবে রাখা হয়েছে। চ্যাটরুম শেয়ারে ক্লিক করুন এবং আপনি একটি পুরস্কার পেতে পারেন!',
    },
    tip: {
      msg: 'আপনার টিকিট সফলভাবে কেনা হয়েছে। অনুগ্রহ করে ড্রয়ের সময়টি লক্ষ্য করুন এবং দ্রুত ফলাফল পরীক্ষা করুন।',
    },
  },
  splash: {
    tip: {
      checkingResources: 'রিসোর্স চেক করা হচ্ছে...',
      checkingVersion: 'সংস্করণ পরীক্ষা করা হচ্ছে...',
      downloading: 'রিসোর্স ডাউনলোড করা হচ্ছে...',
      resolve:
        'রিসোর্স সমাধান করা হচ্ছে (এই প্রক্রিয়াটি নেটওয়ার্ক ব্যবহার করে না)',
      alertTitle: 'আপডেট উপলব্ধ',
      restart: 'পুনরায় চালু করুন',
      alertContent:
        'একটি আপডেট উপলব্ধ। আপডেট প্রয়োগ করতে অ্যাপটি পুনরায় চালু করা হচ্ছে...',
      hasNew: 'নতুন কন্টেন্ট সনাক্ত করা হয়েছে, ডাউনলোড হচ্ছে...',
    },
  },
  recharge: {
    tip: {
      easyPaymentError:
        'Failed to obtain service, please change other payment methods',
      extra: 'Extra {{bonus}} bonus',
    },
    label: {
      extra: 'Extra',
    },
  },
  'recharge-page': {
    currentMethod: 'বর্তমান পদ্ধতি',
    label: {
      records: 'রেকর্ডসমূহ',
      min: 'সর্বনিম্ন',
      max: 'সর্বাধিক',
      channel: 'রিচার্জ চ্যানেল',
      enter: 'রিচার্জ পরিমাণ লিখুন',
      enterText:
        'অনুগ্রহ করে <mark>৫০</mark> এবং <mark>১০০</mark> এর গোল সংখ্যায় লিখুন',
    },
    tip: {
      payMethodTip:
        'বর্তমান পদ্ধতি ব্যর্থ হলে অনুগ্রহ করে অন্য পদ্ধতিতে স্যুইচ করুন।',
      'money-error': 'অনুগ্রহ করে সঠিক পরিমাণ লিখুন',
      'paymethod-error': 'অনুগ্রহ করে পেমেন্ট পদ্ধতি নির্বাচন করুন',
      'no-recharge-customer': 'কোন উপলব্ধ গ্রাহক নেই',
    },
  },
  'bets-page': {
    menu: {
      all: 'সব',
      unknown: 'আঁকা হবে...',
      known: 'আঁকা',
      won: 'জয়',
    },
    filterlabels: {
      kerala: 'কেরলা',
      '3-digit': '3 অঙ্ক',
      'quick-3d': 'দ্রুত 3D',
      color: 'রং',
      'quick-race': 'দ্রুত রেস',
      dice: 'ডাইস',
      'satta-matka': 'সাট্টা মাটকা',
      'scratch-off': 'স্ক্র্যাচ অফ',
      casino: 'ক্যাসিনো',
      live: 'লাইভ',
      sports: 'স্পোর্টস',
      'state-lottery': 'স্টেট লটারি',
      'quick-state-lottery': 'দ্রুত স্টেট লটারি',
    },
    label: {
      share: 'শেয়ার করুন',
      result: 'ফলাফল',
      bettingTime: 'বাজি ধরার সময়',
      shareAwards: 'পুরস্কারের জন্য শেয়ার করুন',
      drawTime: 'ড্র সময়',
      playNow: 'এখন খেলুন',
      viewDetails: 'বিস্তারিত দেখুন',
    },
    status: {
      won: 'জয়',
      noWin: 'জয় নেই',
      drawn: 'আঁকা',
      toBe: 'আঁকা হবে...',
      settling: 'টিকিট নিষ্পত্তি হচ্ছে...',
      settled: 'টিকিট নিষ্পত্তি হয়েছে',
    },
  },
  'bets-detail': {
    label: {
      orderDetail: 'অর্ডারের বিবরণ',
      number: 'নম্বর',
      time: 'সময়',
      payment: 'পেমেন্ট',
      result: 'ফলাফল',
      gameType: 'গেমের ধরণ',
      panel: 'প্যানেল',
      won: 'জয়',
      noWin: 'জয় নেই',
      noDraw: 'আঁকা হবে...',
      settling: 'টিকিট নিষ্পত্তি হচ্ছে...',
      settled: 'টিকিট নিষ্পত্তি হয়েছে',
      draw: 'অঙ্কন',
      totalPoints: 'মোট পয়েন্ট',
      delivery: 'ডেলিভারি',
      fee: 'ফি',
      drawRes: 'অঙ্কিত ফলাফল',
      issue: 'ইস্যু',
      sum: 'যোগফল',
      value: 'মান',
      name: 'নাম',
      type: 'আদর্শ',
      betId: 'বেট আইডি',
    },
  },
  'withdraw-page': {
    label: {
      addBank: 'অ্যাকাউন্ট যোগ করুন',
      transferTo: 'ব্যাংক অ্যাকাউন্টে স্থানান্তর করুন',
      withdrawAmount: 'উত্তোলনযোগ্য পরিমাণ',
      withdrawAmountLower: 'উত্তোলনযোগ্য পরিমাণ',
      received: 'প্রকৃত প্রাপ্ত পরিমাণ:',
      chooseCard: 'একটি ব্যাংক কার্ড বেছে নিন',
      success: 'উত্তোলন সফল হয়েছে',
    },
    tip: {
      withdrawSubmitted:
        'আপনার উত্তোলন জমা দেওয়া হয়েছে অনুগ্রহ করে ধৈর্য ধরুন।',
      transfer: 'উত্তোলন না করে রূপান্তর করলে আপনি একটি উপার্জন করতে পারেন ',
      transferSubmit:
        'নিশ্চিত করুন ক্লিক করার পরে, আপনার উত্তোলনযোগ্য ব্যালেন্স রিচার্জ ওয়ালেটে রূপান্তরিত হবে এবং আপনি সংশ্লিষ্ট বোনাস পাবেন।',
    },
    placeholder: {
      enterAmount: 'উত্তোলনযোগ্য পরিমাণ লিখুন',
    },
    rules: {
      fee: '<0>উত্তোলনের জন্য </0><1>{{percent}}</1><0> পেমেন্ট চ্যানেল ফি ধার্য করা হবে</0>',
      times:
        '<0>প্রতিটি ব্যবহারকারী প্রতিদিন </0><1>{{times}}</1><0> বার উত্তোলন করতে পারবেন।</0>',
      note: '*দ্রষ্টব্য: কিছু ব্যাংক সমস্যার কারণে উত্তোলন বিলম্বিত হতে পারে। এই ক্ষেত্রে, উত্তোলিত পরিমাণ আপনার ওয়ালেটে ফেরত দেওয়া হবে। আপনার ধৈর্যের জন্য ধন্যবাদ।',
      limit:
        'আমরা কিছু অর্থ পাচারের আচরণ খুঁজে পেয়েছি তাই সীমাবদ্ধতা যে রিচার্জের পরিমাণ শুধুমাত্র বাজি ধরার জন্য ব্যবহার করা উচিত। কমিশন এবং জয়ের পরিমাণ অবিলম্বে উত্তোলন করা যাবে।',
    },
    error: {
      addCard: 'প্রথমে একটি ব্যাংক কার্ড যোগ করুন ব্যাংক',
      addAmount: 'অনুগ্রহ করে পরিমাণ লিখুন',
    },
  },
  'bank-page': {
    label: {
      accountName: 'অ্যাকাউন্টের',
      IFSC: 'আইএফএসসি',
      accountNum: 'অ্যাকাউন্ট নম্বর',
      accountNumAgain: 'অ্যাকাউন্ট নম্বর আবার',
      UPI: 'UPI ঠিকানা লিখুন',
      phoneNumber: 'ফোন নম্বর',
      bankName: 'ব্যাংকের নাম',
    },
    placeholder: {
      accountName: 'নাম ইংরেজি অক্ষর (AZ.az) এবং স্থান',
      IFSC: 'কোড দয়া করে আইএফএসসি কোড লিখুন',
      accountNum: '৯-১৭ নম্বর, কোনও জায়গা নেই',
      UPI: 'আপনার UPI আইডি লিখুন।',
      email: 'দয়া করে ইমেইল লিখুন',
      bankName: 'ব্যাংকের নাম নির্বাচন করুন',
    },
    del: {
      confirmTitle: 'ব্যাংক কার্ড মুছুন',
      confirmText: 'আপনি কি নিশ্চিত যে আপনি এই ব্যাংক কার্ডটি মুছতে চান?',
    },
    error: {
      'check-ifsc': 'অনুগ্রহ করে আপনার IFSC কোড পরীক্ষা করুন',
    },
  },
  'transfer-page': {
    label: {
      withdrawable: 'উত্তোলনযোগ্য',
      balance: 'স্থানান্তরযোগ্য ব্যালেন্স',
      balanceTitle: 'রিচার্জ ওয়ালেটে স্থানান্তর করুন',
      willGet: 'পাবেন',
      total: 'মোট ওয়ালেট',
    },
    tip: {
      tip: 'নিশ্চিত করুন ক্লিক করার পরে, আপনার উত্তোলনযোগ্য ব্যালেন্স রিচার্জ ওয়ালেটে রূপান্তরিত হবে এবং আপনি সংশ্লিষ্ট বোনাস পাবেন।',
      success: 'রূপান্তর সফল হয়েছে',
    },
  },
  records: {
    label: {
      amount: 'পরিমাণ',
      channel: 'চ্যানেল',
      received: 'প্রাপ্ত পরিমাণ',
      commission: 'কমিশন',
      withdrawChannel: 'উত্তোলন চ্যানেল',
      orderNum: 'অর্ডার নম্বর',
      reward: 'পুরস্কার',
      order: 'অর্ডার',
      game: 'খেলা',
      types: 'ধরন',
      receiptTime: 'প্রাপ্তির সময়',
    },
    status: {
      PROCESS: 'প্রক্রিয়াধীন...',
      COMPLETE: 'সম্পূর্ণ',
      REVIEW: 'পর্যালোচনায়...',
      FAILED: 'ব্যর্থ হয়েছে',
    },
    tip: {
      error: 'অ্যাকাউন্ট ত্রুটি',
      renewTime: '২৪ ঘন্টার মধ্যে',
    },
  },
  'bets-share': {
    label: {
      share: 'শেয়ার করুন',
      shareSuccess: 'শেয়ার সফল হয়েছে',
      shareFail: 'শেয়ার ব্যর্থ হয়েছে',
      receiving: 'প্রাপ্তির জন্য অভিনন্দন',
      reward: 'পুরস্কার',
      check: 'আপনার নেটওয়ার্ক পরীক্ষা করুন।',
      connection: 'সংযোগ',
      friendlyReminder: 'বন্ধুত্বপূর্ণ অনুস্মারক',
      frTip: 'অনুগ্রহ করে পড়ুন এবং সম্মত হোন',
      frContent: '(প্রাক-বিক্রয় নিয়ম)',
    },
  },
  datePicker: {
    label: {
      select: 'তারিখ নির্বাচন করুন',
    },
  },
  rebate: {
    tabs: {
      all: 'সব',
      finish: 'To Be Finished',
      collect: 'To Be Collected',
      received: 'Received',
    },
    title: 'ছাড়',
    filter: 'Filter',
    undone: 'UNDONE',
    unclaimed: 'Unclaimed',
    completed: 'Completed',
    unfinished: 'Unfinished',
    receive: 'Receive',
    received: 'Received',
    today: 'আজ',
    yesterday: 'গতকাল',
    betting: 'Estimated Betting:',
    rebate: 'Estimated Rebate:',
    congratulations: 'Congratulations!',
    'get-bonus': 'Get Bonus',
    rule: {
      betting: 'Betting Bonus:',
      'betting-detail':
        '{{name}} will rebate users according to the betting amount. The more you bet, the more you get.',
      activity: 'Activity Description:',
      'activity-detail':
        '{{name}} super Bonus rebate activity is open foryou. Every bet will get a rebate Bonus. No matterif you win or lose, you will get Bonus Daily.',
      actrule: 'Activity Rules:',
      'actrule-detail':
        'Players can claim a betting rebate Bonus DailyBonus claim time is after 00:30 the Next Day.',
      precaution: 'Precautions:',
      'precaution-detail-1':
        '-Only the qualified {{name}} members couldparticipate in activities Every member has to complete account detailsin the {name} Account to claim a rebate Bonus.- Any user involved in illegal activities is strictlyprohibited',
      'precaution-detail-2':
        '-Same phone number, bank account number.Email address, and IP address can not be usedfor multiple accounts',
      'precaution-detail-3':
        '-{{name}} has the right to freeze accounts orcancel payments if found illegal/fraudulentactivities committed by individuals or groups intaking advantage of bonuses, (final bonusdecision belongs to {name})',
    },
  },
  wallet: {
    title: 'আমার মানিব্যাগ',
    total: 'মোট মানিব্যাগ',
    game: 'গেমিং ওয়ালেট',
    gameRemind: 'গেমস ওয়ালেট রিমাইন্ডার',
    recharge: 'রিচার্জ',
    main: 'মূল ওয়ালেট',
    third: 'তৃতীয় পক্ষের ওয়ালেট',
    transfer: 'মূল ওয়ালেট স্থানান্তর',
    translation: 'অনুবাদ: {{second}}সে',
    transComplete: 'রূপান্তর সম্পন্ন হয়েছে',
    transferNav: {
      recharge: 'রিচার্জ',
      withdraw: 'প্রত্যাহার করুন',
      transfer: 'স্থানান্তর',
    },
    tip: {
      total:
        'মোট ওয়ালেট ব্যালেন্সে সমস্ত গেম ওয়ালেট এবং আপনার প্রাথমিক ওয়ালেটের ব্যালেন্স অন্তর্ভুক্ত। গেম ওয়ালেট ব্যালেন্স শুধুমাত্র তাদের নিজ নিজ গেমে বাজি ধরার জন্য ব্যবহার করা যেতে পারে।',
      games:
        'গেম ওয়ালেটের পরিমাণ সংশ্লিষ্ট গেমে বাজি ধরার জন্য ব্যবহার করতে সীমাবদ্ধ এবং উত্তোলন করা যাবে না।',
      gaming:
        '{{gameName}} গেম ওয়ালেটের পরিমাণ শুধুমাত্র {{gameName}} গেমে বাজি ধরার জন্য ব্যবহার করা যেতে পারে এবং উত্তোলন করা যাবে না।',
    },
  },
  promotion: {
    title: 'প্রচার',
    go: 'যান',
    playNow: 'এখন খেলুন',
    view: 'দেখুন',
    detail: 'কার্যক্রমের বিবরণ',
    join: 'যোগদান করুন',
    checkin: 'চেক ইন করুন',
    checkinDescription: 'প্রতিদিন চেক ইন করে অনেক পুরস্কার পান',
  },
  'game-page': {
    label: {
      more: 'আরও দেখাও',
      green: 'সবুজ',
      violet: 'বেগুনি',
      red: 'লাল',
      bet: 'বাজি',
      howToPlay: 'কিভাবে খেলতে হবে',
      remaining: 'বাকি সময়',
      issue: 'ইস্যু',
      number: 'নম্বর',
      color: 'রং',
      perriod: 'পিরিয়ড',
      guessWrong: 'দুঃখিত, আপনার অনুমান ভুল, পরের বার চেষ্টা করে দেখুন।',
      ticketSetting: 'নিষ্পত্তির কাজ চলছে, অনুগ্রহ করে অপেক্ষা করুন...',
      guessRight: 'অভিনন্দন, তুমি জিতে গেছো!',
      betTime: 'বাজি ধরার সময়',
      myBets: 'আমার বাজি',
      total: 'মোট পুরস্কারের পরিমাণ',
      drawResult: 'ফলাফল অঙ্কন করুন',
      betResult: 'বাজির ফলাফল',
      wager: 'বাজি',
      payout: 'পরিশোধ',
      Odds: 'সম্ভাবনা',
      odd: 'অদ্ভুত',
      quickGuess: 'দ্রুত অনুমান',
      small: 'ছোট',
      time: 'সময়',
      unused: 'অব্যবহৃত',
      big: 'বড়',
      numbers: 'সংখ্যা',
      playNow: 'এখন খেলুন',
      add: 'যোগ করুন',
      box: 'বাক্স',
      win: 'জয়',
      payment: 'পেমেন্ট',
      single: 'একক',
      double: 'দ্বিগুণ',
      triple: 'ট্রিপল',
      totalLabel: 'মোট',
      digit: 'অঙ্ক',
      myNum: 'আমার নম্বর',
      allEmpty: 'সব খালি',
      result: 'ফলাফল',
      totalPoint: 'TOTAL POINT',
      draw: 'অঙ্কন',
      rule: 'নিয়ম',
      sumType: 'যোগফলের ধরণ',
      sumPoints: 'পয়েন্টের যোগফল',
    },
    'change-bets': {
      p1: 'You have placed an order for the Text',
      p2: 'Are you sure you want to remove your previous selections?',
    },
    tab: {
      result: 'Result history',
      winners: 'Winners',
      analyze: 'Analyze',
      order: 'My order',
    },
    'sale-rules': {
      title: 'Sale Rules',
      p1: 'প্রাক-বিক্রয়ে অংশগ্রহণকারী ব্যবহারকারীদের বৈধ অধিকার এবং স্বার্থ রক্ষা করার জন্য এবং প্রাক-বিক্রয়ের স্বাভাবিক পরিচালনা ক্রম বজায় রাখার জন্য, এই নিয়মগুলি প্রাসঙ্গিক চুক্তি এবং আইন ও প্রবিধান অনুসারে প্রণয়ন করা হয়েছে। দেশ অধ্যায় 1 সংজ্ঞা।',
      p2: '১.১ পূর্ব-বিক্রয় সংজ্ঞা: এমন একটি বিক্রয় মডেলকে বোঝায় যেখানে একজন বিক্রেতা একটি পণ্য বা পরিষেবার একটি বান্ডিল অফার করে, বিক্রির আগে পণ্য সরঞ্জামের মাধ্যমে ভোক্তাদের অর্ডার সংগ্রহ করে এবং গ্রাহকদের কাছে এটি উপলব্ধ করে। পূর্ব চুক্তির মাধ্যমে পণ্য এবং/অথবা পরিষেবার ভোক্তারা',
      p3: '১.২ প্রিসেল মোড হল "ডিপোজিট" মোড। "কনসাইনমেন্ট" বলতে বিক্রয়ের আগে নির্দিষ্ট সংখ্যক আইটেমের প্রি-ডেলিভারি বোঝায়। "ডিপোজিট" কেলেঙ্কারি আরও ডিপোজিট জেতার সুযোগ পেতে মিনি গেমে যোগ দিন। ডিপোজিট সরাসরি পণ্যের জন্য বিনিময় করা যেতে পারে। ডিপোজিট ফেরতযোগ্য নয়।',
      p4: '১.৩ প্রি-সেল পণ্য: এমন একটি পণ্য যা বিক্রেতা প্রি-সেল পণ্য টুল ব্যবহার করে পাঠায়। পণ্যের নাম বা পণ্যের বিবরণ পৃষ্ঠায় শুধুমাত্র প্রি-সেল শব্দটি হাইলাইট করুন এবং যে পণ্যগুলি প্রি-সেল পণ্য টুল ব্যবহার করে না সেগুলি প্রি-সেল নয়।',
      p5: '১.৪ প্রাক-বিক্রয় ব্যবস্থা: বলতে এমন একটি সিস্টেম পণ্য সরঞ্জামকে বোঝায় যা বিক্রেতাদের বিক্রির আগে নমুনা বিক্রি করতে সহায়তা করে।',
      p6: '১.৫ বিক্রির আগে পণ্যের মূল্য: হল বিক্রির আগে পণ্যের বিক্রয় মূল্য। বিক্রয়-পূর্ব পণ্যের মূল্য দুটি অংশ নিয়ে গঠিত: জমা এবং চূড়ান্ত অর্থপ্রদান।',
    },
    tip: {
      paySuccess:
        'আপনার টিকিট সফলভাবে কেনা হয়েছে। অনুগ্রহ করে ড্রয়ের সময়টি লক্ষ্য করুন এবং দ্রুত ফলাফল পরীক্ষা করুন।',
      unable: 'গত {{time}} সেকেন্ডে কিনতে পারছি না',
      single:
        '৩ বা তার বেশি ভিন্ন সংখ্যা বেছে নিন। যদি ড্রয়ের ফলাফল আপনার পছন্দের সাথে মিলে যায়, তাহলে আপনি জিতবেন।',
      double:
        ' ২টি একই সংখ্যা বেছে নিন। যদি ড্রয়ের ফলাফল আপনার নির্বাচনের সাথে মিলে যায়, তাহলে আপনি জিতবেন (যদি না ৩টি সংখ্যা একই হয়)',
      triple:
        '৩টি একই সংখ্যা বেছে নিন। যদি ড্রয়ের ফলাফল আপনার পছন্দের সাথে মিলে যায়, তাহলে আপনি জিতবেন।',
      any: 'যেকোনো ৩টি একই সংখ্যা বেছে নাও। যদি ড্রয়ের ফলাফল একই সংখ্যার যেকোনো তিনটি হয়, তাহলে তুমি জিতবে।',
      'single-odd': '৩টি ভিন্ন সংখ্যা: অডস (৩৪.৫৬)',
      'double-odd': '২টি মিলে যাওয়া সংখ্যা: অডস(১৩.৮৩)',
      'triple-odd': 'একই সংখ্যার ৩: অডস (২০৭.৩৬)',
      'any-odd': 'একই সংখ্যার যেকোনো ৩: অডস (৩৪.৫৬)',
      'tip-clear':
        'অনুগ্রহ করে নিশ্চিত করুন যে আপনি সমস্ত নম্বর মুছে ফেলতে চান?',
    },
    notice: {
      available:
        'Tickets will not be available for purchase 3 minutes before the draw',
    },
  },
  satta: {
    title: {
      betting: 'বাজি ধরা',
      rule: 'নিয়ম',
      history: 'ফলাফলের ইতিহাস',
      order: 'My Order',
      panel: 'PANEL: ',
      open: 'OPEN',
      close: 'CLOSE',
    },
    betting: {
      ank: 'Ank',
      jodi: 'Jodi',
      sp: 'SP',
      dp: 'DP',
      tp: 'TP',
      half: 'Half Sangam',
      full: 'Full Sangam',
      exwinning: 'Expected winning:',
      open: 'open',
      close: 'close',
      paynow: 'Pay Now',
      add: 'যোগ করুন',
      mybids: 'My BIDS',
      bids: 'BIDS',
      tip: {
        enter: {
          amount: 'কেনার পরিমাণ লিখুন',
          open: 'ওপেন ডিজিট লিখুন',
          opens: 'খোলা সংখ্যা লিখুন',
          close: 'বন্ধ সংখ্যা লিখুন',
          closes: 'বন্ধ সংখ্যা লিখুন',
          jodi: 'জোডি ডিজিট লিখুন',
          openpanna: 'পান্না খুলুন',
          closepanna: 'প্রবেশ করুন বন্ধ করুন পান্না',
        },
        require: {
          amount: 'দয়া করে ক্রয়ের পরিমাণ লিখুন',
          open: 'অনুগ্রহ করে খোলা সংখ্যা লিখুন',
          opens: 'খোলা সংখ্যা লিখুন',
          close: 'অনুগ্রহ করে বন্ধ সংখ্যা লিখুন',
          closes: 'অনুগ্রহ করে বন্ধ সংখ্যা লিখুন',
          jodi: 'জোডির সংখ্যা লিখুন',
          openpanna: 'দয়া করে প্রবেশ করুন পান্না খুলুন',
          closepanna: 'দয়া করে প্রবেশ করুন বন্ধ করুন পান্না',
        },
        check: 'Please Enter Completed Digits',
        minAmount: 'The minimum pay amount is {{amount}}',
      },
      digitTitle: {
        ank: 'Single Digit:',
        jodi: 'Jodi Digits:',
        sp: 'Single Patti:',
        dp: 'Double Patti:',
        tp: 'Triple Patti:',
        half: 'HS:',
        full: 'FS:',
      },
      describe: {
        ank: 'খুলুন বা বন্ধ করুন ক্লিক করুন, এবং ইনপুট বাক্সে আপনার পছন্দের একটি সংখ্যা লিখুন, যেমন 1',
        jodi: 'ইনপুট বাক্সে আপনি যে দুই-সংখ্যার নম্বরটি বাজি ধরতে চান তা লিখুন, যেমন 12',
        sp: '"খুলুন" বা "বন্ধ করুন" এ ক্লিক করুন, এবং ইনপুট বাক্সে আপনি যে তিনটি সংখ্যা বাজি ধরতে চান তা লিখুন, যেমন 123।',
        dp: 'ওপেন বা ক্লোজ ক্লিক করুন, এবং ইনপুট বক্সে আপনি যে তিনটি সংখ্যা বাজি ধরতে চান তা লিখুন, দুটি একই সংখ্যা থাকতে হবে, যেমন ১১২',
        tp: 'খুলুন বা বন্ধ করুন ক্লিক করুন, এবং তিনটি একই সংখ্যা লিখুন, যেমন 111',
        half: '"খুলুন" বা "বন্ধ করুন" এ ক্লিক করুন এবং ইনপুট বাক্সে তিনটি বা একটি সংখ্যা লিখুন, যেমন 123 এবং 1,1 এবং 123।',
        full: 'দুটি ইনপুট বাক্সে তিনটি সংখ্যা লিখুন, যেমন 123 এবং 123',
      },
    },
  },
  live: {
    label: {
      category: 'Categories',
      sort: 'Sort by',
    },
  },
  'mix-lotto': {
    tip: {
      disableTip: 'Sorry, you cannot select numbers that are repeated.',
      numUneven: 'You must choose at least one number in each group',
      gameClosed:
        'The game has ended, and betting is not allowed. Please place your bets on other games.',
      numberModeTip:
        'Please select at least 1 number(s) for each digit. Max 100 bet slip count to be created each time.',
      '1digitModeTip': 'Please select at least 1 number for every digit.',
      numberRepeated: 'Sorry, you cannot select numbers that are repeated.',
      betMax: 'Sorry, the maximum number of bets you can place is {{num}}',
      minAmount: 'The minimum amount you can bet is {{num}}',
      beforePlay: 'Please click the add button before making a payment.',
      cantAddToCart:
        'The following combinations will not be added to the shopping cart',
    },
    label: {
      betSlipCount: 'Bet Slip Counts',
      addToBetSlip: 'Add to bet slip',
      gameClosed: 'Game Closed',
      Fish: 'Fish',
      FISH: 'FISH',
      Prawn: 'Prawn',
      PRAWN: 'PRAWN',
      Crab: 'Crab',
      CRAB: 'CRAB',
      Odd: 'Odd',
      Even: 'Even',
      Big: 'বড়',
      est: 'Est. winning',
      Small: 'ছোট',
      BETTYPE: 'Bet Type',
      betAmount: 'Betting amount',
      name: 'India Lottery',
      official: 'Official Draw',
      rule: {
        exapmle: 'Exapmle',
        betOn: 'Player Bet On',
        towSide: {
          BSTitle: '1. Big/Small for Single Digit',
          OETitle: '2. Odd/Even for Single Digit',
        },
        singleTitle: 'Number for Single Digit',
        singleSubTitle: '{{value}} for Single Digit',
        FPCTitle: 'Number for Single Digit is {{value}}',
        FPCSubTitle: 'Number for Single Digit is {{value}}',
        mixTitle: 'Number for {{num}} Digit',
      },
    },
    desc: {
      rule: {
        desc1:
          'India Lottery is based on the result from India official lotteries. Players can bets on the last four digits from official results. For example, official result is 1st Prize : 123456, then the 1st Prize is 3, the 1st Prize-3rd digit is 4, the 1st Prize-2nd digit is 5, the 1st Prize-1st digit is 6.',
        desc2:
          'If there is no result provided by the official site within 24 hours, the bets for the respective draw will be cancelled.',
        desc3:
          "Any amendment made by the game's official site to its results after 24 hours will not be accepted.",
        howToPlay1:
          'When you enter the game, you can see counters available on the screen.',
        howToPlay2:
          'Click on the selection of the counter which you would like to place your bet on. You will be presented with a bet slip where you can key your stake for the bet.',
        howToPlay3:
          'Next, you can select more selection to place bet or click on the "Place Bet" button to confirm all your bet. You may also click on the "Remove" icon to remove single or all bets.',
        howToPlay4:
          'Any bet placed that has not been confirmed will not be accepted by the system. You can refer to "Open Bets" page to see the bet details of your bet. Once the bet has been settled, then your bet can be seen in "Statement" page. In the event that a draw has been cancelled, all bets for the draw will be voided and cancelled.',
        howToPlay5:
          'Our India Lottery wager can be placed on the following bet types, each of the bet types is further explained below',
        betOn: '"{{betValue}}" for the 1st Prize-{{betType}}',
        drawResult: '1st Prize is {{result}}',
        betResult:
          'The 1st Prize-{{betType}} is "{{result}}", which is a "{{betValue}}" number, therefore the bet wins.',
        FPCTitle:
          'Bet placed on a "Fish"/"Prawn"/"Crab" number for a single digit.',
        mixD: 'Choose four numbers to match the results. They need to match exactly. That is, if the bet is {{num}}, the result must also be {{num}}.',
        mixX: 'Choose four numbers to match the results. If the result is a combination of these four numbers, you will win.',
        towSide: {
          BSTitle:
            'Bet placed on a "Big" or "Small" number for a single digit.',
          OETitle: 'Bet placed on a "Odd" or "Even" number for a single digit.',
        },
      },
    },
  },
  sports: {
    selectTip: 'অনুগ্রহ করে একটি স্পোর্টস বেটিং প্ল্যাটফর্ম নির্বাচন করুন',
    sports: 'খেলাধুলা',
    play: 'এখন খেলুন',
  },
  'result-page': {
    label: {
      latestDrawDate: 'সর্বশেষ ড্র তারিখ',
    },
    matka: {
      title: 'Matka',
      open: 'Open',
      close: 'Close',
      ank: 'Ank',
      jodi: 'Jodi',
      sp: 'Single Patti (SP)',
      dp: 'Double Patti (DP)',
      tp: 'Triple Patti (TP)',
      hsa: 'Half Sangam A(HSA)',
      hsb: 'Half Sangam B(HSB)',
      fs: 'Full Sangam',
      panel: 'PANEL',
      types: {
        sp: 'SP',
        dp: 'DP',
        tp: 'TP',
        hs: 'Half Sangam',
      },
    },
  },
};
